import { ReactElement } from 'react';
import { UnitStatus } from '~/providers/types/unit';
import { Badge } from './Badge';
import { useTranslation } from 'react-i18next';

interface StatusBadgeProps {
  production?: number | null;
}

export function StatusBadge({
  production,
}: Readonly<StatusBadgeProps>): ReactElement | null {
  const { t } = useTranslation();
  const canShowBadge = [UnitStatus.MODERNIZATION, UnitStatus.FORCED_UNINSTALL];

  function renderLabel(): string {
    if (String(production) === UnitStatus.MODERNIZATION) {
      return t('unidadeEmModernizacao');
    }

    if (String(production) === UnitStatus.FORCED_UNINSTALL) {
      return t('unidadeEmDesinstalacaoForcada');
    }

    return '';
  }

  if (production && canShowBadge.includes(String(production) as UnitStatus)) {
    return (
      <div>
        <Badge label={renderLabel()} />
      </div>
    );
  }

  return null;
}
